import { Pipe, PipeTransform } from '@angular/core';

// Formats a duration in seconds as "hh:mm:ss", or "mm:ss" when under an hour
@Pipe({
  name: 'videoDuration',
})
export class VideoDurationPipe implements PipeTransform {
  transform(seconds: number): string {
    if (!seconds || seconds < 0) return '';

    const total = Math.round(seconds);
    const hours = Math.floor(total / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const parts = hours ? [hours, minutes, total % 60] : [minutes, total % 60];

    return parts.map((part) => String(part).padStart(2, '0')).join(':');
  }
}
